import React, { useMemo, memo } from 'react';
import { Box, Typography, Icon, Button } from '@material-ui/core';

import useStyles from './styles';

const MsgBox = ({
  type = 'INFO',
  icon = '',
  msg,
  buttonText,
  buttonAction,
}) => {
  const classes = useStyles();

  const typeSettings = useMemo(() => {
    const settings = {
      className: '',
      icon: '',
    };
    switch (type) {
      case 'WARNING':
        settings.className = 'warning';
        settings.icon = 'warning';
        break;
      case 'ERROR':
        settings.className = 'error';
        settings.icon = 'error';
        break;
      case 'SUCCESS':
        settings.className = 'success';
        settings.icon = 'check';
        break;
      case 'INFO':
      default:
        settings.className = 'info';
        settings.icon = 'info';
    }
    if (icon) {
      settings.icon = icon;
    }
    return settings;
  }, [type, icon]);

  return (
    <Box className={`${classes.container} ${typeSettings.className}`}>
      <Icon className="msg-box-icon" fontSize="large">
        {typeSettings.icon}
      </Icon>
      <Typography className="msg-box-text" variant="body1">
        {msg}
      </Typography>
      {!!buttonText && !!buttonAction && (
        <Button className="msg-box-button" onClick={buttonAction}>
          {buttonText}
        </Button>
      )}
    </Box>
  );
};

export default memo(MsgBox);
